import "./CarouselNavArrow.scss";
import React from "react";
import { ChevronIcon } from "Svg/ChevronIcon";
export const CarouselNavArrow = ({ type, className, style, onClick }) => {
    return (React.createElement("button", { className: "carouselNavArrow" + (className ? ` ${className}` : ""), style: style, "aria-label": `carouselNavArrow_${type}`, onClick: onClick },
        React.createElement(ChevronIcon, { style: { transform: `rotate(${type === "next" ? "0deg" : "180deg"})` } })));
};
